import { render, staticRenderFns } from "./error.vue?vue&type=template&id=7e65164f&scoped=true&lang=pug"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.scss?vue&type=style&index=0&id=7e65164f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65164f",
  null
  
)

export default component.exports